export const separateAddressNumberAndAddressStreet = (building: {
  fullAddress: { addressNumber?: string; street: string };
}) => {
  let tempAddress: string[] = [];

  if (
    !building.fullAddress.addressNumber ||
    building.fullAddress.addressNumber == ''
  ) {
    const regex = /(^[0-9]+)(\s)(.*)/i;
    tempAddress = building.fullAddress.street.split(regex);
  }

  return [
    tempAddress[1] || '',
    tempAddress[3] || building?.fullAddress?.street,
  ];
};
